import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import {
  OperationsRoutes,
  QuotaPermissions,
} from '../../constants/operations.constants';
import { OperationsAccessService } from '../../security/services/operations-access.service';
import { quotaAreas } from './quota-navigation';

export const quotaEntryGuard: CanActivateFn = (_, state) => {
  const access = inject(OperationsAccessService);
  const router = inject(Router);
  return access.getCurrentUser().pipe(
    map((user) => {
      if (!access.canAccessModule(user, QuotaPermissions)) {
        return access.redirectToFirstAccessibleRoute(user);
      }
      const url = router.parseUrl(state.url);
      const path = url.root.children['primary']?.segments
        .map((segment) => segment.path)
        .join('/');
      if (path !== OperationsRoutes.quotas) return true;
      const first = quotaAreas
        .flatMap((area) => area.pages)
        .find((page) => access.canAccessModule(user, page.permissions));
      return first
        ? router.createUrlTree(['/' + first.route], {
            queryParams: url.queryParams,
            fragment: url.fragment ?? undefined,
          })
        : access.redirectToFirstAccessibleRoute(user);
    }),
  );
};
